import React, { useEffect, useState } from "react";
import ResizeListener from "../../../../../utility/ResizeListener";
import { CustomButton } from "../../../../components/customButton/CustomButton";
import { CustomInput } from "../../../../components/customInput/CustomInput";
import { BlackClear } from "../../../../resources/assetsManager";
import {
  BG_COLOR,
  LIGHT_GREY_BG_MODAL,
  WHITE_COLOR,
} from "../../../../resources/colorsManager";

function EditBeneficiary({ onClose, onClickSubmit }) {
  const [beneficiaryname, setBeneficiaryName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [ifscCode, setIfscCode] = useState("");
  const [disabled, setDisabled] = useState(true);
  const { width, height } = ResizeListener();
  const inputStyle = {
    backgroundColor: LIGHT_GREY_BG_MODAL,
    alignSelf: "center",
    marginBottom: 15,
    height: 50,
    width: "100%",
    boxShadow: "none",
  };

  useEffect(() => {
    if (
      ifscCode.length === 11 &&
      accountNumber !== "" &&
      beneficiaryname !== ""
    ) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [ifscCode, accountNumber, beneficiaryname]);
  return (
    <>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          marginTop: 20,
          padding: "20px 30px",
          backgroundColor: WHITE_COLOR,
          minWidth: 400,
          borderRadius: 7,
          width: width * 0.35,
          minHeight: height * 0.55,
          height: "100%",
          paddingBottom: 20,
          maxWidth: 400,
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <p
            style={{
              fontSize: 18,
              fontWeight: "600",
              width: "100%",
              textAlign: "center",
            }}
          >
            Edit Beneficiary
          </p>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: BG_COLOR,
              padding: 10,
              borderRadius: 6,
              cursor: "pointer",
            }}
            onClick={onClose}
          >
            <img src={BlackClear} />
          </div>
        </div>
        <div>
          <p
            style={{
              fontSize: 14,
              color: "#888888",
              fontFamily: "Roboto",
            }}
          >
            Customer Basic Information
          </p>
        </div>
        <CustomInput
          value={beneficiaryname}
          onChange={(val) => {
            setBeneficiaryName(val);
          }}
          type="input"
          validator="name"
          inputStyles={{
            ...inputStyle,
          }}
          placeholder="Name as per Bank"
        />

        <CustomInput
          value={accountNumber}
          onChange={(val) => {
            setAccountNumber(val);
          }}
          type="input"
          validator="accountNumber"
          inputStyles={{
            ...inputStyle,
          }}
          placeholder="Account Number"
        />

        <CustomInput
          value={ifscCode}
          onChange={(val) => {
            setIfscCode(val);
          }}
          type="input"
          validator="ifscCode"
          inputStyles={{
            ...inputStyle,
          }}
          placeholder="IFSC Code"
          maxLength={11}
        />

        <CustomButton
          title="Next"
          styles={{
            width: "100%",
            marginTop: 40,
            border: "none",
            height: 45,
            borderRadius: 4,
          }}
          disabled={disabled}
          onClick={() => {
            onClickSubmit({
              ifscCode,
              accountNumber,
              beneficiaryname,
            });
          }}
        />
      </div>
    </>
  );
}

export default EditBeneficiary;
